import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "slug-settings" }
const _hoisted_2 = { class: "row-center mtop-02" }
const _hoisted_3 = { class: "font-m" }
const _hoisted_4 = {
  key: 0,
  class: "slug__empty-institutes font-m row-center mtop-04 gap-02"
}

import { PersonApi } from "@/apiGenerate/medserver";
import ButtonGroup from "@/components/buttonGroup.vue";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { HealthProErrorCode } from "@/models/healthPro.model";
import { InstituteErrorCode } from "@/models/institute.model";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import LoadingSpinner from "@/views/loadingSpinner.vue";
import { useClipboard, useDebounceFn } from "@vueuse/core";
import { InputText, useToast } from "primevue";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'esHealthProSlugSettings',
  props: {
    doctorId: {},
    inputId: {},
    slug: {},
    instituteSlugs: {}
  },
  emits: ["updateSlug"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const personApi = new PersonApi(medServerApiConfig);

const { t } = useI18n();
const { copy, isSupported, copied, text } = useClipboard({ legacy: true, read: true });
const toast = useToast();

const isLoading = ref<boolean>(false);
const slugValue = ref<string>(props.slug);
const errorMessage = ref<string>('');

const fullUrls = computed<string[]>(
    () => props.instituteSlugs.map(instituteSlug => `${process.env.VUE_APP_PATIENT_INSTITUTE_BASE_URL}/${instituteSlug}/${props.slug}`)
);

const debounceSaveSlug = useDebounceFn(async (slug: string) => {
    if (!slug) {
        errorMessage.value = t('settings.params.account.portailPatient.slug.mandatory');
        return;
    }
    
    const isValid = /^[a-zA-Z0-9-]+$/g.test(slug);
    if (!isValid) {
        errorMessage.value = t('settings.params.account.portailPatient.slug.formatError');
        return;
    }

    isLoading.value = true;
    errorMessage.value = '';
    try {
        await personApi.updateDoctorSlug({ doctorId: props.doctorId, updateDoctorSlug: { value: slug } });
        toastSuccess(toast, {
            summary: t("common.toast.success.update"),
            detail: t("settings.params.account.portailPatient.slug.success")
        });
        emit("updateSlug", slug);
    } catch (e) {
        const entries = Object.entries(e);
        const status = entries.find(e => e[0] === 'status');
        if (status && status[1] === HealthProErrorCode.HEALTH_PRO_SLUG_ALREADY_EXISTS) {
            errorMessage.value = t('settings.params.account.portailPatient.slug.alreadyUsed');
        } else {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t('settings.params.account.portailPatient.slug.error')
            });
        }
    }
    isLoading.value = false;
}, 500);

watch(
    slugValue,
    debounceSaveSlug
);

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.account.portailPatient.slug.format'),
        id: `${_ctx.inputId}-description`,
        class: "mtop-02"
      }, null, 8, ["txt", "id"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(InputText), {
          id: _ctx.inputId,
          type: "text",
          size: "small",
          modelValue: slugValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((slugValue).value = $event)),
          class: "w-full",
          disabled: isLoading.value,
          "aria-describedby": `${_ctx.inputId}-error ${_ctx.inputId}-description`,
          required: ""
        }, null, 8, ["id", "modelValue", "disabled", "aria-describedby"]),
        (isLoading.value)
          ? (_openBlock(), _createBlock(LoadingSpinner, {
              key: 0,
              class: "mleft-02",
              logo: false,
              style: 'w-03'
            }))
          : _createCommentVNode("", true)
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_text_item, {
            key: 0,
            txt: errorMessage.value,
            id: `${_ctx.inputId}-error`,
            class: "mtop-02 main-alert"
          }, null, 8, ["txt", "id"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fullUrls.value, (fullUrl) => {
      return (_openBlock(), _createElementBlock("div", {
        key: fullUrl,
        class: "slug__url row-center mtop-04 gap-02"
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(fullUrl), 1),
        (_unref(isSupported))
          ? (_openBlock(), _createBlock(ButtonGroup, {
              key: 0,
              class: "row-center",
              onClick: () => _unref(copy)(fullUrl)
            }, {
              default: _withCtx(() => [
                (_unref(copied) && _unref(text) === fullUrl)
                  ? (_openBlock(), _createBlock(_component_svg_item, {
                      key: 0,
                      icon: "clipboardChecked",
                      styles: "main-m"
                    }))
                  : (_openBlock(), _createBlock(_component_svg_item, {
                      key: 1,
                      icon: "clipboard",
                      styles: "main-m"
                    }))
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (fullUrls.value.length <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('settings.params.account.portailPatient.slug.noInstituteSlugs')), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})